import { computed } from 'vue'

export function useProductList (props) {
    const getSections = computed(() => props?.sections?.length ? props.sections : [])

    const getStyle = computed(() => props.sectionStyle.toLowerCase())

    const getTitleTag = computed(() => {
        if (props.level === 1) {
            return 'h2'
        }

        if (props.level === 2) {
            return 'h3'
        }

        return 'h4'
    })

    return {
        getSections,
        getStyle,
        getTitleTag
    }
}
